/* eslint-disable no-unused-vars */
import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { PillButton } from "../Button";
import styles from "./PillInput.scss";
import { AppContext } from "../../context";
import { BRANDS, MODES } from "../../configs";
import { RadioButtonForm } from "../../views/Shared/RadioButtonForm/RadioButtonForm"

const PillInput = ({ selectedOption, mode, onChange, pillButtonLabel, classnames, isMobile }) => {
	const [useAppState] = AppContext.useAppContext();
	const isSOVBrand = useAppState.brand === BRANDS.SOV;
	const isMobileView = isSOVBrand && window.matchMedia("(max-width: 768px)").matches;
	const isStackMobileLayout = !useAppState.isSOVNewMobileDesign;

	const handleOnChange = value => {
		onChange(value);
	};

	// Exclude the 'multicity' tab for tablet and mobile view (SOV). Display only on desktop devices.
	let tabsForDesktopAndMobile = [...pillButtonLabel];
	if (mode === MODES.TABS || (mode === MODES.SEARCH && isStackMobileLayout && isMobileView)) {
		tabsForDesktopAndMobile = pillButtonLabel.filter(tab => tab.value !== "multicity");
	}

	return (
		<div className={classnames}>
			{tabsForDesktopAndMobile.map(pill => (
				 isMobile ? <RadioButtonForm id={pill.id} value={pill.value} name={pill.label} selectedOption={selectedOption} onChange={() => handleOnChange(pill.value)} /> :
				<PillButton
					key={pill.id}
					brand={useAppState.brand}
					type="button"
					label={pill.label}
					onClick={() => handleOnChange(pill.value)}
					className={cx(styles.button, {
						[styles.buttonSelected]: selectedOption === pill.value,
				})}
				/>
			) )}
		</div>
	);
};

PillInput.propTypes = {
	classnames: PropTypes.string,
	mode: PropTypes.string,
	selectedOption: PropTypes.string,

	isMobile: PropTypes.bool,

	pillButtonLabel: PropTypes.arrayOf(PropTypes.object),

	onChange: PropTypes.func,
};

PillInput.defaultProps = {
	classnames: undefined,
	mode: MODES.SEARCH,
	selectedOption: undefined,

	isMobile: false,
	
	pillButtonLabel: undefined,
	
	onChange: () => {},
};

export default PillInput;
export { PillInput };
